var _defs, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramFollow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.064,
    height: 50.064,
    viewBox: "0 0 50.064 50.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.091,
    y1: 0.909,
    x2: 0.909,
    y2: 0.091,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#f44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c27b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.147,
    y1: 0.854,
    x2: 0.854,
    y2: 0.147,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.146,
    y1: 0.854,
    x2: 0.854,
    y2: 0.146,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9509",
    "data-name": "Path 9509",
    d: "M34.419,0H15.645A15.645,15.645,0,0,0,0,15.645V34.419A15.645,15.645,0,0,0,15.645,50.064H34.419A15.645,15.645,0,0,0,50.064,34.419V15.645A15.645,15.645,0,0,0,34.419,0ZM45.371,34.419A10.964,10.964,0,0,1,34.419,45.371H15.645A10.964,10.964,0,0,1,4.694,34.419V15.645A10.964,10.964,0,0,1,15.645,4.694H34.419A10.964,10.964,0,0,1,45.371,15.645Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9510",
    "data-name": "Path 9510",
    d: "M16.516,4A12.516,12.516,0,1,0,29.032,16.516,12.516,12.516,0,0,0,16.516,4Zm0,20.339a7.823,7.823,0,1,1,7.823-7.823A7.832,7.832,0,0,1,16.516,24.339Z",
    transform: "translate(8.516 8.516)",
    fill: "url(#linear-gradient-2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2829",
    "data-name": "Ellipse 2829",
    cx: 1.668,
    cy: 1.668,
    r: 1.668,
    transform: "translate(36.819 9.91)",
    fill: "url(#linear-gradient-3)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFollow);
export default __webpack_public_path__ + "static/media/instagram-follow.8c479a288afbd1fccbd0903e4e56eab1.svg";
export { ForwardRef as ReactComponent };